__turbopack_context__.v({
  "cardWrap": "zcM0JG_cardWrap",
  "container": "zcM0JG_container",
  "imageWrap": "zcM0JG_imageWrap",
});
